import { Loading } from '@/components/ui/Loading';
import { useI18n } from '@/i18n/context';

export function RouteFallback() {
  const { t } = useI18n();
  return <Loading label={t('app.loading')} />;
}
